<template>
  <div class="intro-y box p-5">
    <div class="text-lg font-bold mb-4 flex flex-row">
      ประเภทของงบประมาณ:
      <OverBudget />
    </div>
    <div>
      <table class="table">
        <thead class="bg-gray-700 dark:bg-dark-1 text-white">
          <tr>
            <th width="70%">Description</th>
            <th width="20%">Total</th>
            <th width="10%"></th>
          </tr>
        </thead>
        <tbody v-if="props.items.length">
          <tr v-for="(summary, index) in props.items" :key="index">
            <td class="border-b dark:border-dark-5" v-html="summary.title"></td>
            <td class="border-b dark:border-dark-5 text-right">
              {{ numberFormat(summary.total) }}
            </td>
            <td class="border-b dark:border-dark-5 text-right">
              {{ summary.currency }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="3">ไม่พบรายการ</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import helpers from '@/helpers'
import OverBudget from '@/components/overBudget.vue'
export default defineComponent({
  props: {
    items: Array,
    default: () => {
      return null
    }
  },
  components: {
    OverBudget
  },
  setup(props) {
    const { numberFormat } = helpers
    return {
      props,
      numberFormat
    }
  }
})
</script>

<style scoped></style>
